'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _icon = require('../icon/icon');

var _icon2 = _interopRequireDefault(_icon);

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./context-menu-item.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function ContextMenuItem(_ref) {
  var icon = _ref.icon,
      children = _ref.children,
      className = _ref.className,
      shortcut = _ref.shortcut,
      disabled = _ref.disabled,
      _onClick = _ref.onClick,
      props = _objectWithoutProperties(_ref, ['icon', 'children', 'className', 'shortcut', 'disabled', 'onClick']);

  var classes = (0, _classnames2.default)('context-menu-item', disabled && 'context-menu-item--disabled', className);

  return _react2.default.createElement(
    'li',
    _extends({
      className: classes,
      onClick: function onClick(event) {
        if (disabled) {
          event.stopPropagation();
          return;
        }

        _onClick(event);
      }
    }, props),
    icon && _react2.default.createElement(_icon2.default, { name: icon, size: '14', className: 'context-menu-item__icon' }),
    _react2.default.createElement(
      'span',
      { className: 'context-menu-item__text' },
      children
    ),
    shortcut && _react2.default.createElement(
      'span',
      { className: 'context-menu-item__shortcut' },
      shortcut
    )
  );
}

ContextMenuItem.propTypes = {
  className: _propTypes2.default.string,
  icon: _propTypes2.default.string,
  shortcut: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
  disabled: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  onClick: _propTypes2.default.func
};

ContextMenuItem.defaultProps = {
  onClick: function onClick() {
    return null;
  }
};

exports.default = ContextMenuItem;